<template>
  <div>
    <div class="box">
      <p class="title is-3-desktop is-4-tablet is-5-mobile center">
        Reporte  Registro de Materiales
      </p>

      <article class="media"></article>
      <div class="media-content">
        <div class="content">
          <div class="columns">
            <div class="column">
              <b-field label="Desde">
                <b-datepicker
                  v-model="dateFrom"
                  placeholder="Ingresa el primer rango"
                  icon="calendar-today"
                  :readonly="false"
                >
                </b-datepicker>
              </b-field>
            </div>

            <div class="column">
              <b-field label="Hasta">
                <b-datepicker
                  v-model="dateTo"
                  :min-date="dateFrom"
                  placeholder="Ingresa el segundo rango"
                  icon="calendar-today"
                  :readonly="false"
                >
                </b-datepicker>
              </b-field>
            </div>

            <div class="column">
              <b-field label="Canal">
                <b-select
                  v-model="canal"
                  placeholder="Selecciona un canal"
                  expanded
                >
                  <option value="TODOS">Todos</option>
                  <option value="TIENDA">TIENDA</option>
                  <option value="RETAIL">RETAIL</option>

                </b-select>
              </b-field>
            </div>

             <div class="column">
              <b-field label="Dirección">
                <b-select
                  v-model="address"
                  placeholder="Selecciona una dirección"
                  expanded
                >
                  <option value="TODOS">Todos</option>
                    <option
                        v-for="option in getClient.addresses"
                        :value="option.id"
                        :key="option.id"
                      >
                        {{ option.name }}
                    </option>
                </b-select>
              </b-field>
            </div>

          </div>

          <div class="center">
            <button
              :disabled="!validateFilters"
              @click="consultarReporteItemMateriales"
              class="button is-success is-rounded"
            >
              Consultar
            </button>
          </div>

          <div class="btn-export report" v-show="itemMateriales.totalElements>0">
            <div>

              <button  @click="doExportReportFilesPdf" class="button  is-small">
                <b-icon icon="file-excel" class="colour-excel"></b-icon> <span style="font-weight:bold"> Descargar Excel </span>
              </button>

            </div>
          </div>

          <section>
             <b-table
                :data="itemMateriales.content"
                paginated
                backend-pagination
                :total="itemMateriales.totalElements"
                :per-page="searchOptions.perPage"
                @page-change="onPageChange"
                :current-page="searchOptions.pageNumber"
              >
              <template slot-scope="props">

                  <b-table-column label="#"  class="is-size-7">
                    {{ props.index + 1 }}
                  </b-table-column>

                  <b-table-column label="Sistema Registro"  class="is-size-7">
                    {{ props.row.sistemaRegistro }}
                  </b-table-column>

                  <b-table-column label="Transacción"  class="is-size-7">
                    {{ props.row.transaccion }}
                  </b-table-column>

                  <b-table-column label="Tipo Transacción"  class="is-size-7">
                    {{ props.row.tipoTransaccion }}
                  </b-table-column>

                  <b-table-column label="Tipo Documento"  class="is-size-7">
                    {{ props.row.tipoDocumento }}
                  </b-table-column>

                  <b-table-column label="N° Documento"  class="is-size-7">
                    {{ props.row.nroDocumento }}
                  </b-table-column>

                  <b-table-column label="Fecha de Transacción"  class="is-size-7">
                    {{ new Date(props.row.fechaTransaccion) | moment("DD/MM/YYYY") }}
                  </b-table-column>

                  <b-table-column label="Identificador Único"  class="is-size-7">
                    {{ props.row.identificador }}
                  </b-table-column>

                  <b-table-column label="Telefono/Celular"  class="is-size-7">
                    {{ props.row.telefonoCelular }}
                  </b-table-column>

                  <b-table-column label="Código Oficina"  class="is-size-7">
                    {{ props.row.address.code }}
                  </b-table-column>

                  <b-table-column label="Nombre Oficina"  class="is-size-7">
                    {{ props.row.address.name }}
                  </b-table-column>
              </template>


              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                    </p>
                    <p>No hay resultados.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from '../../../util'
import { mapActions, mapGetters, mapMutations } from "vuex";
import ReporteItemMateriales from "../../../api/modules/ReporteItemMateriales";

export default {
  data() {

    return {
      searchOptions: {
        perPage: 10,
        pageNumber: 1,
      },
      canal: "TODOS",
      dateFrom: null,
      dateTo: null,
      itemMateriales:[],
      address: "TODOS"

    };
  },
  methods: {

     onPageChange(page) {
      this.searchOptions.pageNumber = page;
      this.consultarReporteItemMateriales();

    },

    consultarReporteItemMateriales(){

      var paramsArray = [
        `pageNumber=${this.searchOptions.pageNumber}`,
        `perPage=${this.searchOptions.perPage}`,
        `fechaInicio=${this.dateFrom}`,
        `fechaFin=${this.dateTo}`,
      ]

      if(this.canal!='TODOS'){
          paramsArray.push(`canal=${this.canal}`);
      }

      if(this.address!='TODOS'){
          paramsArray.push(`address=${this.address}`);
      }

        const params=paramsArray.join("&");

      return new Promise((resolve, reject) => {
        ReporteItemMateriales.getItemMateriales(this, {
          idClient: this.getClient.id,
          param: params,
        })
          .then((data) => {
            this.itemMateriales = data;
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    exportarReporteItemMaterial(email){

      var paramsArray = [
        `fechaInicio=${this.dateFrom}`,
        `fechaFin=${this.dateTo}`,
      ]

      if(this.canal!='TODOS'){
          paramsArray.push(`canal=${this.canal}`);
      }

      if(this.address!='TODOS'){
          paramsArray.push(`address=${this.address}`);
      }
      if(email){
        paramsArray.push(`email=${email}`);
      }
      const params=paramsArray.join("&");
      ReporteItemMateriales.dowloadItemMateriales(this,{
         idClient: this.getClient.id,
         email: email,
          param: params,
      }).then();

    },


    doExportReportFilesPdf(ext) {
      this.$dialog.prompt({
        message: `Se le enviará el reporte a su correo`,
        inputAttrs: {
          placeholder: "Ingrese email",
          maxlength: 30,
        },
        confirmText: "Aceptar",
        cancelText: "Cancelar",
        onConfirm: (email) => {
          this.exportarReporteItemMaterial(email);
          // const params = [`email=${email}`].join("&");
          // this.filters.isExport = true;
          // this.filters.extExport = ext;
          // FileApi.loadReportFiles(this, {
          //   filters: this.filters,
          //   params,
          // }).then();

        },
      });
    },


  },

  computed: {

     ...mapGetters({
      getClient: "auth/getClient",
    }),

    validateFilters() {
      return this.dateTo != null && this.dateFrom != null;
    },
  },
};
</script>
<style scoped>
.report {
  margin-top: 30px;
}
.center {
  text-align: center;
}
.btn-export {
  text-align: right;
  margin-bottom: 0.25rem;
}
.break-word {
  word-break: break-all;
}
.colour-pdf {
  color: red;
}
.colour-excel {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/reportes/materiales/ReporteMateriales.vue